import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { map } from 'rxjs';

export const simGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.currentUser$.pipe(
    map((userState) => {
      if (userState.puk && userState.iccd && userState.phone) {
        return true;
      }
      return router.createUrlTree(['']);
    }),
  );
};
